export default {
      id: "chevron-usage",
      viewBox: "0 0 451.847 451.847",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#chevron",
      toString: function () {
        return this.url;
      }
    }